/**
 * Plugin to capture and manage the backbutton.
 * Usage:
 * window.backbuttonListener.addListener(string id, () => {//your magic} [,(bool)mobileonly]);
 * window.backbuttonListener.deleteListener(string id);
 *
 * @type {{}}
 */
window.backbuttonListener = {};

backbuttonListener.listeners = new Map();

/**
 * Add the listener and
 *
 * @param callback the function to execute when the backbutton is pushed.
 * @param mobileonly only on mobile.
 */
backbuttonListener.addListener = (id, callback, mobileonly = true) => {
    // When identifier
    let identifier = ((typeof id === "string")
        ? id
        : 'id_' + Math.floor(Math.random() * 1000000000).toString());
    if (mobileonly && ($(window).width() > 767)) {
        return;
    }

    // Wait to allow pushstates by other scripts.
    setTimeout(() => {
        let newUrl = location.href
                .replace(location.hash, '')
                .replace('#', '')
            + '#' + identifier;

        let listener = {
            newUrl: newUrl,
            oldUrl: location.href,
            callback: callback,
        };
        // change the state to pick up the popstate.
        backbuttonListener.listeners.set(identifier, listener);
        history.pushState({}, document.title, newUrl);
    }, 500);
}

/**
 * Remove the listerer, and replace the state if called for.
 *
 * @param id
 */
backbuttonListener.deleteListener = (id) => {
    // Check to see if the url is create by the listener, otherwise replace the state.
    let listener = backbuttonListener.listeners.get(id);
    if (listener !== undefined) {
        if (listener.newUrl === location.href) {
            history.replaceState({}, document.title, listener.oldUrl);
        }
        backbuttonListener.listeners.delete(id);
    }
}

/**
 * alias for deleteListener.
 * @param id
 */
backbuttonListener.removeListener = (id) => {
    backbuttonListener.deleteListener(id);
}

/**
 * Execute all callbacks when the back button is pushed.
 *
 * @param e
 * @returns {boolean}
 */
backbuttonListener.handle = (e) => {
    if (backbuttonListener.listeners.size > 0) {
        backbuttonListener.listeners.forEach((listener, id) => {
            if (listener.oldUrl === location.href) {
                e.preventDefault();
                listener.callback();
                backbuttonListener.deleteListener(id);
            }
        });
        return false;
    }
    return true;
}

$(document).ready(function ($) {
    // Catch the backbutton and send it to the handler.
    $(window).on('popstate', function (e) {
        window.backbuttonListener.handle(e);
    });
});
